import React, { Component } from 'react';
import Header from '../Header';
import Notification from '../Notification';
import * as s from '../../styles/style';
import styled from 'styled-components';

const Column = styled.div`
  max-width: 850px;
  padding: 32px 10px 50px;
  width: 100%;
  margin: 0 auto;
`

class Page extends Component {
  constructor(props) {
    super(props)
    window.scrollTo(0,0)
  }
  render() {
    return (
      <s.Main width="100%">
        <Header currentUser={this.props.currentUser}/>
        <Notification type={this.props.alertType} message={this.props.alertMessage} />
        <Column>{this.props.children}</Column>
      </s.Main>
    )
  }
}

export default Page